<template>
    <v-layout row wrap class="mt-3">
        <v-flex xs12>
            <confirmation-header-text text="Organization detail" class="ml-0 mb-5"
                                      icon="business"></confirmation-header-text>
        </v-flex>
        <v-flex sm4 xs12 class="pr-2">
            <v-text-field
                label="Organization name"
                outlined
                type="text"
                v-model="visa.extra.application_data.organization_name"
            ></v-text-field>
        </v-flex>
        <v-flex sm4 xs12 class="pr-2">
            <address-auto-complete
                label="Address of organization"
                v-model="visa.extra.application_data.address_of_business_institute"
                country-code="np"
            ></address-auto-complete>
        </v-flex>
        <v-flex sm4 xs12 class="pr-2">
            <v-text-field
                label="Position in organization "
                outlined
                type="text"
                v-model="visa.extra.application_data.position"
            ></v-text-field>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        data: () => ({
            addressLoading: false,
        }),
        components: {
            "address-auto-complete": AddressAutoComplete, ConfirmationHeaderText
        },
        computed: {
            visa() {
                return this.$store.state.VisaRequestSingle.visaRequest;
            }
        },

    };
</script>

<style>
</style>
